'use strict';

angular.module('ClinicApp').controller('BulkMessagingModalSuccessCtrl', function($scope, $modalInstance, status) {
  $scope.status = status;

  $scope.close = function(status) {
    $modalInstance.close();
    if (status === 'success') {
      location.reload();
    }
  };
});
